/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col lg:w-2/12 md:w-2/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank flex flex-wrap gap-4">
              <h5 class="dragBlock font-semibold cursor-pointer">rate == 42</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">rate > 42</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">rate =< 42</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">rate = 42</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-10/12 md:w-10/12 sm:w-5/5">
          <div class="main-border rounded-lg bg-dark p-6 flex flex-col gap-4">
            <h3>rate = 21 * 2 // 1</h3>

            <span class="flex items-center gap-2">
              <h3>if</h3>
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-48" id="input0" />
              <h3>:</h3>
            </span>

            <h3 class="ml-8 text-grey">print("*")</h3>

            <span class="flex items-center gap-2">
              <h3>elif</h3>
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-48" id="input1" />
              <h3>:</h3>
            </span>

            <h3 class="ml-8 text-grey">print("**")</h3>

            <h3 class="">else:</h3>
            <h3 class="ml-8 text-grey">print("***")</h3>
          </div>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    markSimulation() {
      let totalScore = 0;

      if (document.getElementById('input0').textContent === 'rate > 42') {
        document.getElementById('input0').style.borderColor = '#28C76F';
        totalScore++;
      }
      if (document.getElementById('input1').textContent === 'rate == 42') {
        document.getElementById('input1').style.borderColor = '#28C76F';
        totalScore++;
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      return this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
